import httpClient from './httpClient';

const API_BASE = '/api/leftovers';

const leftoverService = {
  async findAvailable(params) {
    const response = await httpClient.get(`${API_BASE}/available`, { params });
    return response.data;
  },

  async getById(id) {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  }
};

export default leftoverService;
